export class EventManager {
  constructor() {
    this._listeners = new Map();
  }

  subscribe(eventType, listener) {
    const listeners = this._listeners.get(eventType) ?? new Set();
    listeners.add(listener);
    this._listeners.set(eventType, listeners);

    return () => {
      listeners.delete(listener);
      if (listeners.size === 0) {
        this._listeners.delete(eventType);
      }
    };
  }

  notify(eventType, payload) {
    if (!this._listeners.has(eventType)) return;

    this._listeners.get(eventType).forEach((listener) => {
      listener(payload);
    });
  }
}
